// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import AvatarField from './AvatarField.js';
import ComplexField from './ComplexField.js';

const BriefField = function ({ size, field }) {
  if (size === 'large') {
    return (
      <div className="d-flex align-items-center">
        <AvatarField size="xl" field={field} />
        <div className="fs-2 pt-1">
          <div className="fs-6 text-muted fw-light">{field.label}</div>
          <ComplexField field={field} />
        </div>
      </div>
    );
  }
  else {
    return (
      <div>
        <div className="fw-bold">
          {field.label}
        </div>
        <div className="pt-1 d-flex align-items-center">
          <AvatarField field={field} />
          <ComplexField field={field} />
        </div>
      </div>
    );
  }
}

export default BriefField;
